/** The signed-in person's queries; everything about them sits under `me`. */
export const identityKeys = {
  me: () => ['identity', 'me'] as const,
  /** The address their agent commits are authored with (spec 158). */
  commitEmail: () => ['identity', 'me', 'commit-email'] as const,
  /** Their linked forge accounts, and the hosts they could link (spec 159). */
  forgeAccounts: () => ['identity', 'me', 'forge-accounts'] as const,
  forgeHosts: () => ['identity', 'me', 'forge-hosts'] as const,
  /**
   * Whether a workspace requires their own account, and which hosts they lack
   * (spec 160). Without a workspace, the prefix linking invalidates.
   */
  personalAccountStanding: (workspaceId?: string) =>
    workspaceId === undefined
      ? (['identity', 'me', 'personal-account-standing'] as const)
      : (['identity', 'me', 'personal-account-standing', workspaceId] as const),
};
